/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { rolesParaInspeccion } from 'app/permisosMenusRutas';

export const defaultNavigation: FuseNavigationItem[] = [

];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'usuario-dashboard',
        title: 'Mis trámites',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/usuario-dashboard',
        permissions: ["ROLE_ADMIN", "ROLE_USER"]
    },
    {
        id: 'usuario-pagos',
        title: 'Mis pagos',
        type: 'basic',
        icon: 'heroicons_outline:credit-card',
        link: '/usuario-pagos',
        permissions: ["ROLE_ADMIN", "ROLE_USER"]
    },
    {
        id: 'usuario-dictamenes',
        title: 'Mis dictamenes',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/usuario-dictamenes',
        permissions: ["ROLE_ADMIN", "ROLE_USER"]
    },
    {
        id: 'dictamenes',
        title: 'Dictamenes',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/dictamenes',
        permissions: ["ROLE_ADMIN", "ROLE_REVISOR_FOMENTO","ROLE_JEFE_DEPARTAMENTO"]
    },
    {
        id: 'new-link',
        title: 'Vista Revisor',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/dashrevisor',
        permissions: ["ROLE_ADMIN", "ROLE_REVISOR_FOMENTO","ROLE_JEFE_DEPARTAMENTO"]
    },
    {
        id: 'new-link',
        title: 'Otros elementos',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/solicitudes',
        permissions: ["ROLE_ADMIN"]
    },
    {
        id: 'inspector',
        title: 'Inspector',
        type: 'basic',
        icon: 'heroicons_outline:magnifying-glass-circle',
        link: '/dashinspector',
        permissions: [...rolesParaInspeccion]
    }

];

export const futuristicNavigation: FuseNavigationItem[] = [
   
];

export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'usuario-dashboard',
        title: 'Mis trámites',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/usuario-dashboard',
        permissions: ["ROLE_ADMIN", "ROLE_USER"]
    },
    {
        id: 'usuario-pagos',
        title: 'Mis pagos',
        type: 'basic',
        icon: 'heroicons_outline:credit-card',
        link: '/usuario-pagos',
        permissions: ["ROLE_ADMIN", "ROLE_USER"]
    },
    {
        id: 'usuario-dictamenes',
        title: 'Mis dictamenes',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/usuario-dictamenes',
        permissions: ["ROLE_ADMIN", "ROLE_USER"]
    },
    {
        id: 'dictamenes',
        title: 'Dictamenes',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: '/dictamenes',
        permissions: ["ROLE_ADMIN", "ROLE_REVISOR_FOMENTO","ROLE_JEFE_DEPARTAMENTO"]
    },
    {
        id: 'new-link',
        title: 'Vista Revisor',
        type: 'basic',
        icon: 'heroicons_outline:document',
        link: '/dashrevisor',
        permissions: ["ROLE_ADMIN", "ROLE_REVISOR_FOMENTO","ROLE_JEFE_DEPARTAMENTO"]
    },
    {
        id   : 'catalogos',
        title: 'Catálogos',
        type : 'group',
        icon : 'heroicons_outline:document-duplicate', 
        permissions: ["ROLE_ADMIN","ROLE_CATALOGOS"],
        children: [
            {
                id   : 'usuarios',
                title: 'Usuarios',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/tablausuario',
            },
            {
                id   : 'colonias',
                title: 'Colonias',
                type : 'basic',
                icon : 'heroicons_outline:map-pin',
                link : '/tabladomicilio',
            },
            {
                id   : 'sian',
                title: 'SIAN',
                type : 'basic',
                icon : 'heroicons_outline:archive-box',
                link : '/tablasian',
            },
            {
                id   : 'categorias',
                title: 'Categorías',
                type : 'basic',
                icon : 'heroicons_outline:tag',
                link : '/tablacategorias',
            },
            {
                id   : 'categorias-requisitos',
                title: 'Categorías Requisitos',
                type : 'basic',
                icon : 'heroicons_outline:document-check',
                link : '/tablacategorias-requisitos',
            },
            {
                id   : 'documentos',
                title: 'documentos',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-document',
                link : '/tabla-documentos',
            },
            {
                id   : 'documentos-requisitos',
                title: 'Tramites Requisitos',
                type : 'basic',
                icon : 'heroicons_outline:folder-open',
                link : '/tabla-tramites-requisitos',
            },      
        ]
        
    },

    {
        id: 'inspector',
        title: 'Inspector',
        type: 'basic',
        icon: 'heroicons_outline:magnifying-glass-circle',
        link: '/dashinspector',
        permissions: [...rolesParaInspeccion]
    }

    
];
